import { render, staticRenderFns } from "./GameRadarChart.vue?vue&type=template&id=2e1e7686&scoped=true"
import script from "./GameRadarChart.vue?vue&type=script&lang=js"
export * from "./GameRadarChart.vue?vue&type=script&lang=js"
import style0 from "./GameRadarChart.vue?vue&type=style&index=0&id=2e1e7686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e7686",
  null
  
)

export default component.exports